/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { HttpUrlEncodingCodec } from '@angular/common/http';

/**
 * @link https://www.ietf.org/rfc/rfc3986.txt
 *
 * URI producing applications should percent-encode data octets that correspond to characters
 * in the reserved set unless these characters are specifically allowed by the URI scheme to
 * represent data in that component. If a reserved character is found in a URI component and
 * no delimiting role is known for that character, then it must be interpreted as representing
 * the data octet corresponding to that character's encoding in US-ASCII.
 */
export class DashGisHttpUrlEncodingCodec extends HttpUrlEncodingCodec {

    encodeKey(key: string): string {
        return super.encodeKey(key)
            .replace(/'/g, '%27') // single quotes are permitted to be unencoded in urls
            .replace(/%5B/g, '[')
            .replace(/%5D/g, ']')
    }

    encodeValue(value: string): string {
        return super.encodeValue(value)
            .replace(/'/g, '%27'); // single quotes are permitted to be unencoded in urls
    }
}
